import React, { ReactNode } from 'react';
import Box from '@mui/material/Box';

function TabPanel({ activeTab, index, children }: { activeTab: number; index: number; children: ReactNode }) {
  if (activeTab !== index) {
    return null;
  }

  return <Box sx={{ p: { xs: 2.5, md: 3 } }}>{children}</Box>;
}

export default TabPanel;
